module.exports = __webpack_public_path__ + "static/media/boolean_input.13cc9995.PNG";